import { ChainId } from 'vvs-sdk'
import { NFT_TYPE } from 'config/constants/nftTypes'
import { serializeTokens } from './tokens'
import { SerializedFarmConfig } from './types'

const serializedTokens = serializeTokens()
// FIXME update pid, address and tokens for LP

export const mainnetFarms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'VVS',
    lpAddresses: {
      338: '0x904Bd5a5AAC0B9d88A0D47864724218986Ad4a3a',
      25: '0x2D03bECE6747ADC00E1a131BBA1469C15fD11e03',
    },
    token: serializedTokens.workbench,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  // {
  //   pid: 251,
  //   lpSymbol: 'CAKE-BNB LP',
  //   lpAddresses: {
  //     338: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
  //     25: '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0',
  //   },
  //   token: serializedTokens.cake,
  //   quoteToken: serializedTokens.wbnb,
  // },
  // {
  //   pid: 252,
  //   lpSymbol: 'BUSD-BNB LP',
  //   lpAddresses: {
  //     338: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
  //     25: '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16',
  //   },
  //   token: serializedTokens.busd,
  //   quoteToken: serializedTokens.wbnb,
  // },
  {
    pid: 1,
    lpSymbol: 'CRO-ETH LP',
    lpAddresses: {
      338: '0xD37d267B2161035A9CF2023F9753CddbfC8B90F3',
      25: '0xA111C17f8B8303280d3EB01BBcd61000AA7F39F9',
    },
    token: serializedTokens.eth,
    quoteToken: serializedTokens.wcro,
    version: 1,
    enableBoost: true,
  },
  {
    pid: 2,
    lpSymbol: 'CRO-WBTC LP',
    lpAddresses: {
      338: '0xbDAA80e9EA59bFD3A8AE5705c66804F2e1D9D508',
      25: '0x8F09fFf247B8fDB80461E5Cf5E82dD1aE2EBd6d7',
    },
    token: serializedTokens.wbtc,
    quoteToken: serializedTokens.wcro,
    version: 1,
    enableBoost: true,
  },
  {
    pid: 3,
    lpSymbol: 'CRO-USDC LP',
    lpAddresses: {
      338: '0x5323D7CE6a12282c0448d255d8B5EDc9918E52Da',
      25: '0xe61Db569E231B3f5530168Aa2C9D50246525b6d6',
    },
    token: serializedTokens.usdc,
    quoteToken: serializedTokens.wcro,
    version: 1,
    enableBoost: true,
  },
  {
    pid: 4,
    lpSymbol: 'CRO-VVS LP',
    lpAddresses: {
      338: '0x3F3465b412B6017E20AF7ABFFAB67698de8cFa7a',
      25: '0xbf62c67eA509E86F07c8c69d0286C0636C50270b',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.wcro,
    version: 1,
    enableBoost: true,
  },
  {
    pid: 5,
    lpSymbol: 'VVS-USDC LP',
    lpAddresses: {
      338: '0x9e3A0434ED428dFDe5ace779ead35e141DD95eFf',
      25: '0x814920d1b8007207db6cb5a2dd92bf0b082bdba1',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdc,
    version: 1,
    enableBoost: true,
  },
  {
    pid: 6,
    lpSymbol: 'USDC-USDT LP',
    lpAddresses: {
      338: '',
      25: '0x39cC0E14795A8e6e9D02A21091b81FE0d61D82f9',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.usdc,
    version: 1,
  },
  {
    pid: 7,
    lpSymbol: 'VVS-USDT LP',
    lpAddresses: {
      338: '',
      25: '0x280aCAD550B2d3Ba63C8cbff51b503Ea41a1c61B',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdt,
    version: 1,
    enableBoost: true,
  },
  {
    pid: 8,
    lpSymbol: 'CRO-SHIB LP',
    lpAddresses: {
      338: '',
      25: '0xc9eA98736dbC94FAA91AbF9F4aD1eb41e7fb40f4',
    },
    token: serializedTokens.shib,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 9,
    lpSymbol: 'CRO-USDT LP',
    lpAddresses: {
      338: '',
      25: '0x3d2180DB9E1B909f35C398BC39EF36108C0FC8c3',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 10,
    lpSymbol: 'CRO-DAI LP',
    lpAddresses: {
      338: '',
      25: '0x3Eb9FF92e19b73235A393000C176c8bb150F1B20',
    },
    token: serializedTokens.dai,
    quoteToken: serializedTokens.wcro,
    version: 1,
    isFinished: true,
  },
  {
    pid: 11,
    lpSymbol: 'CRO-BIFI LP',
    lpAddresses: {
      338: '',
      25: '0x1803E360393A472beC6E1A688BDF7048d3076b1A',
    },
    token: serializedTokens.bifi,
    quoteToken: serializedTokens.wcro,
    version: 1,
    isFinished: true,
  },
  {
    pid: 12,
    lpSymbol: 'CRO-DOGE LP',
    lpAddresses: {
      338: '',
      25: '0x2A560f2312CB56327AD5D65a03F1bfEC10b62075',
    },
    token: serializedTokens.doge,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 13,
    lpSymbol: 'CRO-ATOM LP',
    lpAddresses: {
      338: '',
      25: '0x9e5bd780dff875Dd85848a65549791445AE25De0',
    },
    token: serializedTokens.atom,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 14,
    lpSymbol: 'TONIC-USDC LP',
    lpAddresses: {
      338: '',
      25: '0x2f12D47Fe49B907d7a5Df8159C1CE665187F15c4',
    },
    token: serializedTokens.tonic,
    quoteToken: serializedTokens.usdc,
    version: 1,
    isFinished: true,
  },
  {
    pid: 15,
    lpSymbol: 'CRO-ELON LP',
    lpAddresses: {
      338: '',
      25: '0x7AaF2e3AFde06A7f9E686c1dDE4fAB14979384ce',
    },
    token: serializedTokens.elon,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 16,
    lpSymbol: 'CRO-TONIC LP',
    lpAddresses: {
      338: '',
      25: '0x4B377121d968Bf7a62D51B96523d59506e7c2BF0',
    },
    token: serializedTokens.tonic,
    quoteToken: serializedTokens.wcro,
    version: 1,
    enableBoost: true,
    boostFarmExpired: true,
  },
  {
    pid: 17,
    lpSymbol: 'SINGLE-VVS LP',
    lpAddresses: {
      338: '',
      25: '0x6f72a3f6dB6F486B50217f6e721f4388994B1FBe',
    },
    token: serializedTokens.single,
    quoteToken: serializedTokens.vvs,
    version: 1,
    isFinished: true,
  },
  {
    pid: 18,
    lpSymbol: 'SINGLE-USDC LP',
    lpAddresses: {
      338: '',
      25: '0x0fBAB8A90CAC61b481530AAd3a64fE17B322C25d',
    },
    token: serializedTokens.single,
    quoteToken: serializedTokens.usdc,
    version: 1,
    isFinished: true,
  },
  {
    pid: 19,
    lpSymbol: 'VVS-TONIC LP',
    lpAddresses: {
      338: '',
      25: '0xA922530960A1F94828A7E132EC1BA95717ED1eab',
    },
    token: serializedTokens.tonic,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x5C78a8dEAd748Ccfa3D1e70E72854D0CaB2eeAd0',
        },
        token: serializedTokens.tonic,
        isFinished: true,
      },
    ],
    startFrom: '2022-08-16T09:00:00.000Z',
    isFinished: false,
    enableBoost: true,
  },
  {
    pid: 20,
    lpSymbol: 'TUSD-USDC LP',
    lpAddresses: {
      338: '',
      25: '0x94fd83482016bcc5fca5972a3635aa6524c3f557',
    },
    token: serializedTokens.tusd,
    quoteToken: serializedTokens.usdc,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x3AD05dc5Ca8407c0C8386F505e482Ec7ed6DE015',
        },
        token: serializedTokens.tusd,
        isFinished: true,
      },
    ],
    isFinished: true,
  },
  {
    pid: 21,
    lpSymbol: 'CRO-APE LP',
    lpAddresses: {
      338: '',
      25: '0x2eA92065D2c2908bB3C7d6BB9318aF4F8d735dD5',
    },
    token: serializedTokens.ape,
    quoteToken: serializedTokens.wcro,
    version: 1,
    isFinished: true,
  },
  {
    pid: 22,
    lpSymbol: 'CRO-ALI LP',
    lpAddresses: {
      338: '',
      25: '0x78082d9Dee5FDD53dF3b16292077Ee2F6D31F7DE',
    },
    token: serializedTokens.ali,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x041e27fC23BD30687C798767Cd2222CC8937b1fF',
        },
        token: serializedTokens.ali,
        isFinished: true,
      },
    ],
    isFinished: true,
  },
  {
    pid: 24,
    lpSymbol: 'CRO-DARK LP',
    lpAddresses: {
      338: '',
      25: '0x9284134f3D268CDf0Ef2305c9F06767E913A7CE6',
    },
    token: serializedTokens.dark,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x818692dce30CF6fe47a4AEaa1517bD934B52C7d3',
        },
        token: serializedTokens.dark,
        isFinished: true,
      },
    ],
    isFinished: true,
  },
  {
    pid: 25,
    lpSymbol: 'CRO-SKY LP',
    lpAddresses: {
      338: '',
      25: '0x542b3bA420581b69212F406e0643Da75fA109b79',
    },
    token: serializedTokens.sky,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0xa2D38F5884deaF87254B43F47Ed89D88B5A87482',
        },
        token: serializedTokens.sky,
        isFinished: true,
      },
    ],
    isFinished: true,
  },
  {
    pid: 26,
    lpSymbol: 'CRO-NESS LP',
    lpAddresses: {
      338: '',
      25: '0xD9DEBAab797Cb92C257B2988AaFA92C728B124E6',
    },
    token: serializedTokens.ness,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x24C840E3d4c346C912DA09967D300E3DdE851BE1',
        },
        token: serializedTokens.ness,
        isFinished: true,
      },
    ],
    isFinished: true,
  },
  {
    pid: 27,
    lpSymbol: 'VVS-V3S LP',
    lpAddresses: {
      338: '',
      25: '0x57b975364140e4a8d1C96FAa00225b855BaB0E8E',
    },
    token: serializedTokens.v3s,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x81C17eBbaF467A65B1C085dBd7278b3C05D57cdA',
        },
        token: serializedTokens.vshare,
        isFinished: true,
      },
    ],
    isFinished: true,
  },
  {
    pid: 28,
    lpSymbol: 'CRO-VSHARE LP',
    lpAddresses: {
      338: '',
      25: '0xcb0704BC4E885384ac96F0ED22B9204C3adD91AD',
    },
    token: serializedTokens.vshare,
    quoteToken: serializedTokens.wcro,
    version: 2,
    isFinished: true,
  },
  {
    pid: 29,
    lpSymbol: 'CRO-AKT LP',
    lpAddresses: {
      338: '',
      25: '0x3daff925e2e392Efe499610e56E3Cc2053e85a86',
    },
    token: serializedTokens.akt,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x1ea16ae1F08E792c804e6E1060224ae209C341eC',
        },
        token: serializedTokens.akt,
        isFinished: true,
      },
    ],
    isFinished: true,
  },
  {
    pid: 30,
    lpSymbol: 'VVS-VERSA LP',
    lpAddresses: {
      338: '',
      25: '0xD7F3d8035cd7BD5aD5E43Fa4E1d4DcA12e133FdD',
    },
    token: serializedTokens.versa,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x27d8fEa87107D6b28F1B9108889CF7456B7e4725',
        },
        token: serializedTokens.versa,
        isFinished: true,
      },
    ],
    isFinished: true,
  },
  {
    pid: 31,
    lpSymbol: 'VVS-ARGO LP',
    lpAddresses: {
      338: '',
      25: '0x89b330F8E31a1238b667080a0a6e4e5c4C15f7eE',
    },
    token: serializedTokens.argo,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x4782BB48C4ceD542Db0dfdfFCa72ce7631C9f461',
        },
        token: serializedTokens.argo,
        isFinished: true,
      },
    ],
    startFrom: '2022-04-29T15:00:00.000Z',
    isFinished: true,
  },
  {
    pid: 32,
    lpSymbol: 'ARGO-USDC LP',
    lpAddresses: {
      338: '',
      25: '0xDcBe2035a7b24f7AA479BFf3cCA46d2F5f014B74',
    },
    token: serializedTokens.argo,
    quoteToken: serializedTokens.usdc,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x4782BB48C4ceD542Db0dfdfFCa72ce7631C9f461',
        },
        token: serializedTokens.argo,
        isFinished: true,
      },
      {
        address: {
          338: '',
          25: '0x5b31c45688B83E6322704154b3778aCB66857b95',
        },
        token: serializedTokens.xargo,
      },
      {
        address: {
          338: '',
          25: '0x2D326c0be04F1e3c6Dd95e70323ea047FD49FE9d',
        },
        token: serializedTokens.xargo,
        nft: NFT_TYPE.ARGO, // 2022.10.14 only support : one farm with one rewarderV2 contract; if need to support one farm with multi rewarderV2, will need SC & FE further changes
      },
    ],
    startFrom: '2022-04-29T15:00:00.000Z',
    ecoFarm: NFT_TYPE.ARGO,
  },
  {
    pid: 33,
    lpSymbol: 'BUSD-USDC LP',
    lpAddresses: {
      338: '',
      25: '0x792Df67276615d6E85e36497c4514b7b102Af4A9',
    },
    token: serializedTokens.busd,
    quoteToken: serializedTokens.usdc,
    version: 2,
    startFrom: '2022-09-29T09:00:00.000Z',
    isFinished: true,
  },
  {
    pid: 34,
    lpSymbol: 'CRO-BCRO LP',
    lpAddresses: {
      338: '',
      25: '0xd0BE1AaBA78b7b4eb4C09719317529108a0d5C54',
    },
    token: serializedTokens.bcro,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0xb7A4C788020A037CE91bF24e986CB04448b63FdE',
        },
        token: serializedTokens.xargo,
      },
      {
        address: {
          338: '',
          25: '0xc8432607e92EB1293334682dfAe7FF2E35EcAc31',
        },
        token: serializedTokens.xargo,
        nft: NFT_TYPE.ARGO, // 2022.10.14 only support : one farm with one rewarderV2 contract; if need to support one farm with multi rewarderV2, will need SC & FE further changes
      },
    ],
    startFrom: '2022-06-01T15:00:00.000Z',
    ecoFarm: NFT_TYPE.ARGO,
  },
  {
    pid: 35,
    lpSymbol: 'CRO-CROGE LP',
    lpAddresses: {
      338: '',
      25: '0xB7b49d3c3F94C32C8b3e8F065Ddb8D31EDd13157',
    },
    token: serializedTokens.croge,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x639A895D0C6f11586433406b2BF0F4f8F62B6951',
        },
        token: serializedTokens.croge,
        isFinished: true,
      },
      {
        address: {
          338: '',
          25: '0x85f803181B924F57f0f0f498d33c1D29Db180C96',
        },
        token: serializedTokens.croge,
      },
    ],
    startFrom: '2022-06-02T12:00:00.000Z',
    isFinished: true,
  },
  {
    pid: 36,
    lpSymbol: 'VVS-FER LP',
    lpAddresses: {
      338: '',
      25: '0x72eFd454bBFEca458e909B99FAACBC116880b54D',
    },
    token: serializedTokens.fer,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x90D01A7f45aa09f2f9f2e5Daa1B9989B17CF6196',
        },
        token: serializedTokens.fer,
        isFinished: true,
      },
    ],
    startFrom: '2022-08-16T09:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 37,
    lpSymbol: 'MTD-VVS LP',
    lpAddresses: {
      338: '',
      25: '0xf10af2E06908A8f234678974712B60DE3063609B',
    },
    token: serializedTokens.mtd,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0xE07be9F892Eb897a2A25D79818cF559FE2526B79',
        },
        token: serializedTokens.mtd,
        isFinished: true,
      },
    ],
    startFrom: '2022-08-10T11:00:00.000Z',
    enableBoost: true,
  },
  {
    pid: 18,
    lpSymbol: 'SINGLE-USDC LP',
    lpAddresses: {
      338: '',
      25: '0x0fBAB8A90CAC61b481530AAd3a64fE17B322C25d',
    },
    token: serializedTokens.single,
    quoteToken: serializedTokens.usdc,
    version: 2,
    suffix: '(ep.2)',
    rewarders: [
      {
        address: {
          338: '',
          25: '0x0CD65177086A79741c3117Ae474599295f5F89c8',
        },
        token: serializedTokens.single,
      },
    ],
    startFrom: '2022-07-19T09:00:00.000Z',
    migration: true,
  },
  {
    pid: 38,
    lpSymbol: 'CRO-FIRA LP',
    lpAddresses: {
      338: '',
      25: '0x689E7BA5170001aC887965a5Db1C9Ce932c93462',
    },
    token: serializedTokens.fira,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0xD5e4a4dE1f1005c3D860B3dF5a8380Eead6e65c8',
        },
        token: serializedTokens.fira,
      },
    ],
    startFrom: '2022-09-01T01:00:00.000Z',
    isFinished: true,
  },
  {
    pid: 47,
    lpSymbol: 'VVS-CROID LP',
    lpAddresses: {
      338: '',
      25: '0xc43e32F44423AE7562c33ED8CA8394969bfffb29',
    },
    token: serializedTokens.croid,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x1D5B295eA535EA878DF384C7D4558b9E9309f544',
        },
        token: serializedTokens.croid,
      },
    ],
    startFrom: '2022-11-17T11:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 50,
    lpSymbol: 'VVS-VNO LP',
    lpAddresses: {
      338: '',
      25: '0x34d1856ED8BBc20FA7b29776ad273FD8b22967BE',
    },
    token: serializedTokens.vno,
    quoteToken: serializedTokens.vvs,
    version: 2,
    enableBoost: true,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x96917e287F04dd24720D3733dDe17967A67d08B8',
        },
        token: serializedTokens.vno,
        isFinished: true,
      },
    ],
    startFrom: '2023-01-18T10:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 51,
    lpSymbol: 'VVS-FUL LP',
    lpAddresses: {
      338: '',
      25: '0x6ae624714f221964aff3AB8D8276a7ec142a759f',
    },
    token: serializedTokens.ful,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x862C41c4a9b3a21989585Fd92b66C7023FCf4C7D',
        },
        token: serializedTokens.ful,
      },
    ],
    startFrom: '2023-03-17T11:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 52,
    lpSymbol: 'VVS-BONE LP',
    lpAddresses: {
      338: '',
      25: '0xC9dFf49302b8b6b99b1D677d19C061eeC25FD94F',
    },
    token: serializedTokens.bone,
    quoteToken: serializedTokens.vvs,
    version: 2,
    startFrom: '2023-03-28T09:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 53,
    lpSymbol: 'CRO-XRP LP',
    lpAddresses: {
      338: '',
      25: '0xe83FfaD6c8ceC615B7A8d7c96706F717E91784D2',
    },
    token: serializedTokens.xrp,
    quoteToken: serializedTokens.wcro,
    version: 2,
    startFrom: '2023-04-20T09:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 54,
    lpSymbol: 'CRO-ADA LP',
    lpAddresses: {
      338: '',
      25: '0x28cC282E101789135aCe6CD408231B651cE53b53',
    },
    token: serializedTokens.ada,
    quoteToken: serializedTokens.wcro,
    version: 2,
    startFrom: '2023-04-20T09:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 55,
    lpSymbol: 'CRO-VNO LP',
    lpAddresses: {
      338: '',
      25: '0x523ad524721957c31Ca53512A4E50d82F53c5cAe',
    },
    token: serializedTokens.vno,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x57E673F3920F4629bdc272180aB3714F257B2d59',
        },
        token: serializedTokens.vno,
      },
    ],
    startFrom: '2023-04-28T09:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 56,
    lpSymbol: 'CRO-FUL LP',
    lpAddresses: {
      338: '',
      25: '0x9B5a553f3E081999f0a6A3d582fD7Dc49e12761B',
    },
    token: serializedTokens.ful,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x55Cb523C22590160E897015d195C7F3986Ca345B',
        },
        token: serializedTokens.ful,
      },
    ],
    startFrom: '2023-04-28T09:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 57,
    lpSymbol: 'CRO-BEAT LP',
    lpAddresses: {
      338: '',
      25: '0xF7cEC263278f458D87bA55f1e6dCC52F46493321',
    },
    token: serializedTokens.beat,
    quoteToken: serializedTokens.wcro,
    version: 2,
    startFrom: '2023-04-26T09:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 59,
    lpSymbol: 'LCRO-CRO LP',
    lpAddresses: {
      338: '',
      25: '0xbA5cc14D3D83Ba0881B046D5487760cf669f6F4e',
    },
    token: serializedTokens.lcro,
    quoteToken: serializedTokens.wcro,
    version: 2,
    startFrom: '2023-05-11T09:00:00.000Z',
    isFinished: false,
  },
  {
    pid: 60,
    lpSymbol: 'FLOKI-VVS LP', // for FLOKI mine to calculate APR
    lpAddresses: {
      338: '',
      25: '0x3b3Ae49bDD1159909fE9c3E53F89Adf27C97D829',
    },
    token: serializedTokens.floki,
    quoteToken: serializedTokens.vvs,
    version: 1,
    isFinished: true,
  },
  {
    pid: 61,
    lpSymbol: 'VVS-PEPE LP',
    lpAddresses: {
      338: '',
      25: '0xb90d6e09075168281D47dA6f0665ff4fd8f0Ff6f',
    },
    token: serializedTokens.pepe,
    quoteToken: serializedTokens.vvs,
    version: 2,
    startFrom: '2023-06-05T11:00:00.000Z',
  },
  {
    pid: 62,
    lpSymbol: 'VVS-CORGIAI LP',
    lpAddresses: {
      338: '',
      25: '0xfc07bf38408e4326f99dec96ba94f1e28af68842',
    },
    token: serializedTokens.corgiai,
    quoteToken: serializedTokens.vvs,
    version: 2,
    startFrom: '2023-06-08T11:00:00.000Z',
    rewarders: [
      {
        address: {
          338: '',
          25: '0xee568D5068b4E03763023FD23fa437B60590b32a',
        },
        token: serializedTokens.corgiai,
      },
    ],
  },
  {
    pid: 63,
    lpSymbol: 'WBTC-USDC LP',
    lpAddresses: {
      338: '',
      25: '0xd6E42E6052561e6Eb1b71D0045B7b1bfbDD43DC8',
    },
    token: serializedTokens.wbtc,
    quoteToken: serializedTokens.usdc,
    version: 2,
    startFrom: '2023-06-12T09:00:00.000Z',
  },
  {
    pid: 64,
    lpSymbol: 'WETH-USDC LP',
    lpAddresses: {
      338: '',
      25: '0xfd0Cd0C651569D1e2e3c768AC0FFDAB3C8F4844f',
    },
    token: serializedTokens.weth,
    quoteToken: serializedTokens.usdc,
    version: 2,
    startFrom: '2023-06-12T09:00:00.000Z',
  },
  {
    pid: 65,
    lpSymbol: 'WBTC-USDT LP',
    lpAddresses: {
      338: '',
      25: '0xB30846a0DAF03Fb2f2a9A42a4F4A2Bb6A81022d4',
    },
    token: serializedTokens.wbtc,
    quoteToken: serializedTokens.usdt,
    version: 2,
    startFrom: '2023-06-12T09:00:00.000Z',
  },
  {
    pid: 66,
    lpSymbol: 'WETH-USDT LP',
    lpAddresses: {
      338: '',
      25: '0x4b40A4bc7f929F32a0f4B349Eda217764eE9d30E',
    },
    token: serializedTokens.weth,
    quoteToken: serializedTokens.usdt,
    version: 2,
    startFrom: '2023-06-12T09:00:00.000Z',
  },
  {
    pid: 67,
    lpSymbol: 'WBTC-WETH LP',
    lpAddresses: {
      338: '',
      25: '0x5D9ec21ea6B7a90943377424EdD6e81F843bBD26',
    },
    token: serializedTokens.wbtc,
    quoteToken: serializedTokens.weth,
    version: 2,
    startFrom: '2023-06-12T09:00:00.000Z',
  },
  {
    pid: 68,
    lpSymbol: 'CRO-MATIC LP',
    lpAddresses: {
      338: '',
      25: '0x18AE87AE14279D42fCdde542c7Faa65768434024',
    },
    token: serializedTokens.matic,
    quoteToken: serializedTokens.wcro,
    version: 2,
    startFrom: '2023-06-12T09:00:00.000Z',
  },
  {
    pid: 69,
    lpSymbol: 'FRTN-USDC LP',
    lpAddresses: {
      338: '',
      25: '0xBc10BeD82041a5D1abad43Cc206656AafE9f84E6',
    },
    token: serializedTokens.frtn,
    quoteToken: serializedTokens.usdc,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0x80691A4F127710D6CdC67C7961A90878355dD73c',
        },
        token: serializedTokens.frtn,
      },
    ],
    startFrom: '2023-06-16T09:00:00.000Z',
  },
  {
    pid: 70,
    lpSymbol: 'BCRO-GOLD LP',
    lpAddresses: {
      338: '',
      25: '0x941cf6f28FeF3fD44d8cC4d1d7AF4d7294B17036',
    },
    token: serializedTokens.bcro,
    quoteToken: serializedTokens.gold,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0xBb27CC2b984EB10948045c6A38B8FA296e16a05E',
        },
        token: serializedTokens.stardust,
      },
    ],
    startFrom: '2023-06-16T07:00:00.000Z',
    isFinished: true,
  },
  {
    pid: 71,
    lpSymbol: 'CRO-GOLD LP',
    lpAddresses: {
      338: '',
      25: '0x0db713667292c9fd0cc146f39132bb62058f8314',
    },
    token: serializedTokens.gold,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0xe2776bc9E0d3999e18094C6a66988Ba4571F1672',
        },
        token: serializedTokens.stardust,
      },
    ],
    startFrom: '2023-06-16T14:00:00.000Z',
  },
  {
    pid: 72,
    lpSymbol: 'CRO-LTC LP',
    lpAddresses: {
      338: '',
      25: '0x802B04879a8Fbe1C9dABc3f51Ea8E91942b7a439',
    },
    token: serializedTokens.ltc,
    quoteToken: serializedTokens.wcro,
    version: 2,
    startFrom: '2023-07-03T09:00:00.000Z',
  },
  {
    pid: 73,
    lpSymbol: 'CRO-BCH LP',
    lpAddresses: {
      338: '',
      25: '0x69D3a652A65dFc18Cd1eF6B6307fbAE1f2AB1fac',
    },
    token: serializedTokens.bch,
    quoteToken: serializedTokens.wcro,
    version: 2,
    startFrom: '2023-07-03T09:00:00.000Z',
  },
  {
    pid: 74,
    lpSymbol: 'CRO-CORGIAI LP',
    lpAddresses: {
      338: '',
      25: '0x8F9baCcf9a130a755520cBabB20543adb3006f14',
    },
    token: serializedTokens.corgiai,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0xD8e768B64621E2f6c57F4bAa977EB2A7EcF023D4',
        },
        token: serializedTokens.corgiai,
      },
    ],
    startFrom: '2023-07-04T09:00:00.000Z',
  },
  {
    pid: 75,
    lpSymbol: 'LMWR-VVS LP', // for LMWR mine to calculate APR
    lpAddresses: {
      338: '',
      25: '0x34F3Ea1F2f8B58026C73695171760c35160C65Ad',
    },
    token: serializedTokens.lmwr,
    quoteToken: serializedTokens.vvs,
    version: 1,
    isFinished: true,
  },
  {
    pid: 76,
    lpSymbol: 'CORGIAI-USDC LP',
    lpAddresses: {
      338: '',
      25: '0x189291476338446C6E62c8A18Ef22d3c80Eb5F72',
    },
    token: serializedTokens.corgiai,
    quoteToken: serializedTokens.usdc,
    version: 2,
    rewarders: [
      {
        address: {
          338: '',
          25: '0xEABc72c985310356a810fe48421711B8Aa8a6Ab8',
        },
        token: serializedTokens.corgiai,
      },
    ],
    startFrom: '2023-07-21T09:00:00.000Z',
  },
]

const testnetFarms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'VVS',
    lpAddresses: {
      338: '0x904Bd5a5AAC0B9d88A0D47864724218986Ad4a3a',
      25: '',
    },
    token: serializedTokens.workbench,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 1,
    lpSymbol: 'CRO-ETH LP',
    lpAddresses: {
      338: '0xD37d267B2161035A9CF2023F9753CddbfC8B90F3',
      25: '',
    },
    token: serializedTokens.eth,
    quoteToken: serializedTokens.wcro,
    version: 1,
    enableBoost: true,
    boostFarmExpired: true,
  },
  {
    pid: 2,
    lpSymbol: 'CRO-WBTC LP',
    lpAddresses: {
      338: '0xbDAA80e9EA59bFD3A8AE5705c66804F2e1D9D508',
      25: '',
    },
    token: serializedTokens.wbtc,
    quoteToken: serializedTokens.wcro,
    version: 1,
    enableBoost: true,
    boostFarmExpired: true,
  },
  {
    pid: 3,
    lpSymbol: 'CRO-VVS LP',
    lpAddresses: {
      338: '0x3F3465b412B6017E20AF7ABFFAB67698de8cFa7a',
      25: '',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.wcro,
    version: 1,
    isFinished: false,
    enableBoost: true,
    boostFarmExpired: true,
  },
  // deprecated
  // {
  //   pid: 4,
  //   lpSymbol: 'CRO-USDC LP',
  //   lpAddresses: {
  //     338: '0x5323D7CE6a12282c0448d255d8B5EDc9918E52Da',
  //     25: '',
  //   },
  //   token: serializedTokens.usdc,
  //   quoteToken: serializedTokens.wcro,
  // },
  {
    pid: 5,
    lpSymbol: 'VVS-USDC LP',
    lpAddresses: {
      338: '0x9e3A0434ED428dFDe5ace779ead35e141DD95eFf',
      25: '',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdc,
    version: 1,
    enableBoost: true,
    boostFarmExpired: true,
  },
  {
    pid: 6,
    lpSymbol: 'CRO-USDC LP',
    lpAddresses: {
      338: '0xaC7901EFB1F279a18e3f1973664cF4057DdbF0d9',
      25: '',
    },
    token: serializedTokens.usdc,
    quoteToken: serializedTokens.wcro,
    version: 1,
    enableBoost: true,
    boostFarmExpired: true,
  },
  {
    pid: 7,
    lpSymbol: 'USDC-USDT LP',
    lpAddresses: {
      338: '0xFd8e08cEEA14eC83277518ec892A7f17CB04a06a',
      25: '',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.usdc,
    version: 1,
  },
  {
    pid: 8,
    lpSymbol: 'VVS-USDT LP',
    lpAddresses: {
      338: '0x21D3283f9519D99Ca598a68DC23F286e244Df820',
      25: '',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdt,
    version: 1,
    enableBoost: true,
  },
  {
    pid: 9,
    lpSymbol: 'CRO-SHIB LP',
    lpAddresses: {
      338: '0x502494fa12459568c2f57bE01636b0724cc95190',
      25: '',
    },
    token: serializedTokens.shib,
    quoteToken: serializedTokens.wcro,
    version: 1,
    isFinished: true,
  },
  // {
  //   pid: 10,
  //   lpSymbol: 'VVS-PIZZA LP',
  //   lpAddresses: {
  //     338: '0x502494fa12459568c2f57bE01636b0724cc95190',
  //     25: '',
  //   },
  //   token: serializedTokens.pizza,
  //   quoteToken: serializedTokens.vvs,
  // },
  // {
  //   pid: 11,
  //   lpSymbol: 'USDC-PIZZA LP',
  //   lpAddresses: {
  //     338: '0x555302ED60Fd293A79C6bA0d05e8711a53c9a7Ce',
  //     25: '',
  //   },
  //   token: serializedTokens.pizza,
  //   quoteToken: serializedTokens.usdc,
  // },
  {
    pid: 12,
    lpSymbol: 'CRO-PIZZA LP',
    lpAddresses: {
      338: '0x65741A08Ecfa072A92862c2822Ffa3f83b3c10F9',
      25: '',
    },
    token: serializedTokens.pizza,
    quoteToken: serializedTokens.wcro,
    version: 1,
  },
  {
    pid: 14,
    lpSymbol: 'CRO-MUFFIN LP',
    lpAddresses: {
      338: '0x7463b52174Bcb8decd352F5A055C76df6e808A13',
      25: '',
    },
    token: serializedTokens.muffin,
    quoteToken: serializedTokens.wcro,
    version: 1,
    isFinished: true,
  },
  {
    pid: 15,
    lpSymbol: 'GINGER-USDC LP',
    lpAddresses: {
      338: '0xf13C07a34327715F0FE4dc824e1C1B3D86785F26',
      25: '',
    },
    token: serializedTokens.ginger,
    quoteToken: serializedTokens.usdc,
    version: 1,
    isFinished: true,
  },
  {
    pid: 17,
    lpSymbol: 'VVS-START LP',
    lpAddresses: {
      338: '0x2030bBf39537bb629E9D849Bf2478C958745fb6b',
      25: '',
    },
    token: serializedTokens.start,
    quoteToken: serializedTokens.vvs,
    version: 2,
  },
  {
    pid: 18,
    lpSymbol: 'VVS-START1 LP',
    lpAddresses: {
      338: '0xa46dA4Fb44D6586f4E9d128eF29C763698E15152',
      25: '',
    },
    token: serializedTokens.start1,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0x1cDC9978937ee248DC1D7CF1f1bF7225200eEf22',
          25: '',
        },
        token: serializedTokens.start1,
      },
    ],
  },
  {
    pid: 19,
    lpSymbol: 'VVS-START2 LP',
    lpAddresses: {
      338: '0x0b001d4f0df9a75B6c19ca761538ACc7ed4dBfeA',
      25: '',
    },
    token: serializedTokens.start2,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0x1cDC9978937ee248DC1D7CF1f1bF7225200eEf22',
          25: '',
        },
        token: serializedTokens.start1,
      },
      {
        address: {
          338: '0x95114BC2d515d1EE9bA60c7eF54De0d3aA047e2D',
          25: '',
        },
        token: serializedTokens.start2,
      },
    ],
  },
  {
    pid: 20,
    lpSymbol: 'VVS-ROSE LP',
    lpAddresses: {
      338: '0x71F67b48B4C7BFde2415a1cEa48A06518FFA8Fcc',
      25: '',
    },
    token: serializedTokens.rose,
    quoteToken: serializedTokens.vvs,
    version: 2,
    isFinished: true,
  },
  {
    pid: 21,
    lpSymbol: 'VVS-ROSE1 LP',
    lpAddresses: {
      338: '0xa42ea26d9f9b9927001A42A7B5869c2486Db9607',
      25: '',
    },
    token: serializedTokens.rose1,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0x67c1326Da97dD0f14fAa1e5e0208Fb3FDfabc6Ae',
          25: '',
        },
        token: serializedTokens.rose1,
      },
      {
        address: {
          338: '0x95114BC2d515d1EE9bA60c7eF54De0d3aA047e2D',
          25: '',
        },
        token: serializedTokens.start2,
      },
    ],
    isFinished: true,
  },
  {
    pid: 22,
    lpSymbol: 'VVS-ROSE2 LP',
    lpAddresses: {
      338: '0x37D4E1f3041310edA54f7937e97366aA96eBEE9c',
      25: '',
    },
    token: serializedTokens.rose2,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0xe36BD0FB72fa70eF5057D7b323b164fB3EF15C60',
          25: '',
        },
        token: serializedTokens.rose2,
      },
      {
        address: {
          338: '0x1cDC9978937ee248DC1D7CF1f1bF7225200eEf22',
          25: '',
        },
        token: serializedTokens.start1,
      },
    ],
  },
  {
    pid: 23,
    lpSymbol: 'CRO-START1 LP',
    lpAddresses: {
      338: '0x321E3a6AEA4723e164f3b223aa50cfBDa5146EBb',
      25: '',
    },
    token: serializedTokens.start1,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0x1cDC9978937ee248DC1D7CF1f1bF7225200eEf22',
          25: '',
        },
        token: serializedTokens.start1,
      },
      {
        address: {
          338: '0x800fd2B53F67b939344AD907F41423A93cDddbc0',
          25: '',
        },
        token: serializedTokens.usdc,
      },
    ],
  },
  {
    pid: 28,
    lpSymbol: 'CRO-BCRO LP',
    lpAddresses: {
      338: '0x127295b26CF3B48904305e0C12E0Cc95A319605A',
      25: '',
    },
    token: serializedTokens.bcro,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0xbE401722F76d29F9DF36588aeF2288bB915C073e',
          25: '',
        },
        token: serializedTokens.xrose1,
      },
    ],
    startFrom: '2022-06-01T15:00:00.000Z',
  },
  {
    pid: 46,
    lpSymbol: 'FakeFarm LP',
    lpAddresses: {
      338: '0x5d4ede693a0f8580574cf44877274a63c2837e1d',
      25: '',
    },
    token: serializedTokens.wcro,
    quoteToken: serializedTokens.vvs,
    version: 1,
    enableBoost: true,
  },
  {
    pid: 49,
    lpSymbol: 'CRO-BCRO LP',
    lpAddresses: {
      338: '0x127295b26CF3B48904305e0C12E0Cc95A319605A',
      25: '',
    },
    token: serializedTokens.bcro,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0xC805e1A30f4B70eB719032943354392eFDA2b620',
          25: '',
        },
        token: serializedTokens.devArgo,
      },
    ],
    startFrom: '2022-06-01T15:00:00.000Z',
    isFinished: true,
  },
  {
    pid: 50,
    lpSymbol: 'VVS-ARGO LP',
    lpAddresses: {
      338: '0xFB4D25f4DC54E5E996c03C29313F053250Ef7f0B',
      25: '',
    },
    token: serializedTokens.devArgo,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0x0C0E5Edb57D2CB8cD943fF2fB9faD8E60bE73CE8',
          25: '',
        },
        token: serializedTokens.devArgo,
        nft: NFT_TYPE.ARGO, // 2022.10.14 only support : one farm with one rewarderV2 contract; if need to support one farm with multi rewarderV2, will need SC & FE further changes
      },
      {
        address: {
          338: '0x0c786915dA7F2e701741AB776A5B1ed8D5c37E15',
          25: '',
        },
        token: serializedTokens.devArgo,
      },
    ],
    startFrom: '2022-06-01T15:00:00.000Z',
    ecoFarm: NFT_TYPE.ARGO,
    isFinished: true,
  },
  {
    pid: 51,
    lpSymbol: 'VVS-ARGO2 LP',
    lpAddresses: {
      338: '0xFB4D25f4DC54E5E996c03C29313F053250Ef7f0B',
      25: '',
    },
    token: serializedTokens.devArgo,
    quoteToken: serializedTokens.vvs,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0x6D75d49026556DfB0A39bF2c03fb46D51cD05a7f',
          25: '',
        },
        token: serializedTokens.devArgo,
      },
      {
        address: {
          338: '0xc6862a512A6F78c43737D7F8f98a4cA73E9b24AD',
          25: '',
        },
        token: serializedTokens.devArgo,
        nft: NFT_TYPE.ARGO, // 2022.10.14 only support : one farm with one rewarderV2 contract; if need to support one farm with multi rewarderV2, will need SC & FE further changes
      },
    ],
    startFrom: '2022-06-01T15:00:00.000Z',
    ecoFarm: NFT_TYPE.ARGO,
  },
  {
    pid: 56,
    lpSymbol: 'CRO-ROSE LP',
    lpAddresses: {
      338: '0xD87742468C7837FcDFBDC07F5B2D3E451E0B129f',
      25: '',
    },
    token: serializedTokens.rose,
    quoteToken: serializedTokens.wcro,
    version: 2,
    rewarders: [
      {
        address: {
          338: '0x20fB55d3f95E5768c92DEdAC0104cD4785512c94',
          25: '',
        },
        token: serializedTokens.rose,
      },
    ],
    enableBoost: true,
  },
]

const farms: SerializedFarmConfig[] =
  process.env.REACT_APP_CHAIN_ID === ChainId.MAINNET.toString() ? mainnetFarms : testnetFarms

export default farms
